import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-off-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './eye-off-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class EyeOffIconComponent {}
